<template lang="">
	<div>
		<v-card class="d-flex justify-space-between pa-5 mb-8">
      <div class="d-flex flex-row">
        <v-select
          v-model="selected"
          placeholder="Produto"
          class="b-4 h-48 mr-5 widthRespondive py-2"
          :options="productsList"
        />
        <v-select
          v-model="status"
          placeholder="Status"
          class="b-4 h-48 widthRespondive py-2"
          :options="options"
        />
      </div>
			<div class="button-wrapper d-flex justify-space-between">
				<v-btn
					@click="filterList"
          :style="disabled ? 'background: var(--grey-day-030);' : 'background: var(--red)'"
          :disabled="disabled"
          outlined
          height="48"
          class="d-flex align-center mr-5"
          :class="disabled ? 'b-4' : 'b-red'"
          width="120"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text d-flex align-center justify-space-around"
						>
						<img class="pr-2" src="../../../../static/images/search.svg">
						<span style="color: var(--white)">Buscar</span>
					</div>
				</v-btn>
        <v-btn
					@click="clearForm"
          style="background: var(--white); color: var(--dark-grey)"
          outlined
          height="48"
          class="d-flex align-center b-clear"
          width="120"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text d-flex align-center"
						>
						<img class="pr-2" src="../../../../static/images/load.svg">
						Limpar
					</div>
				</v-btn>
			</div>
		</v-card>
	</div>
</template>
<script>
// Lib
import { mapActions, mapMutations, mapState } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

import VueCookies from 'vue-cookies'

export default {
	components: {
		ClipLoader
	},
  data() {
    return {
      selected: '',
      status: null,
      disabled: true,
      options: [
        {
          value: 'true',
          label: 'Ativo',
        },
        {
          value: 'false',
          label: 'Inativo',
        }
      ],
    }
  },
  async created() {
    this.status = null
    this.selected = ''
    this.productItems
  },
  computed: {
    ...mapState('Product', {
      productItems: 'items',
      loading: 'loading',
      loadingClear: 'loadingClear'
    }),
    ...mapState('Copy', {
      loading: 'loading'
    }),
    productsList () {
      const products = this.productItems.data ? this.productItems.data : []
      return products.map(product =>({
        value: product.product_id,
        label: product.product_name
      }))
    }
  },
  methods: {
    ...mapActions('Copy', [
      'getCopies'
    ]),
    ...mapMutations('Copy', {
      setLoading: 'SET_LOADING',
      setStatusFilter: 'SET_STATUS_FILTER',
      setProductFilter: 'SET_PRODUCT_FILTER',
      setPage: 'SET_PAGE'
    }),
    ...mapMutations('Product', {
      setLoadingClear: 'SET_LOADING_CLEAR',
    }),
    async filterList () {
      this.disabled = true
      this.setLoading(true)
      this.setPage(0)
      if (this.status !== null) {
        this.setStatusFilter(this.status.value)
        this.setProductFilter('')
      } else {
        this.setStatusFilter(null)
      }
      if (this.selected !== '') {
        this.setProductFilter(this.selected.value)
        this.setStatusFilter(null)
      } else {
        this.setProductFilter('')
      }
      if (this.status !== null && this.selected !== '') {
        this.setStatusFilter(this.status.value)
        this.setProductFilter(this.selected.value)
      }
      const token = VueCookies.get('jwt-login')
      try {
        await this.getCopies({token: token})
        this.setLoading(false)
      } catch (error) {
        return error
      }
    },
    async clearForm() {
      this.setLoadingClear(true)
      const token = VueCookies.get('jwt-login')
      this.status = null
      this.selected = ''
      this.setStatusFilter(null)
      this.setProductFilter('')
      await this.getCopies({token: token})
      this.setLoadingClear(false)
      this.setLoading(false)
    }
  },
  watch: {
    'status' () {
      this.status !== null || this.selected !== null ? this.disabled = false : this.disabled = true
    },
    'selected' () {
      this.status !== null || this.selected !== null ? this.disabled = false : this.disabled = true
    }
  }
}
</script>

<style lang="scss" scoped>
.b-4 {
	border: 2px solid var(--grey-day-030);
	border-radius: 4px;
}

.b-red {
  border: 2px solid var(--red)
}

.b-clear {
  border: 1px solid var(--grey-day);
}

.h-48 {
  height: 48px
}

.vs__dropdown-toggle {
	border: none !important;
}

.vs__search {
	display: flex;
  align-items: center;
  color: #7d7d7d
}

.widthRespondive {
  width: 420px;
}

@media screen and (max-width: 1377px) {
  .widthRespondive {
    width: 238px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/CopyFilter.vue